/**
 * VoltNova Shopify Theme - JavaScript
 * Version: 1.0.0
 */

(function() {
  'use strict';

  // ============================================
  // Cookie Consent
  // ============================================
  const CookieConsent = {
    STORAGE_KEY: 'voltnova_cookie_consent',
    
    init() {
      const consent = localStorage.getItem(this.STORAGE_KEY);
      const banner = document.querySelector('.cookie-consent');
      
      if (!consent && banner) {
        setTimeout(() => {
          banner.classList.add('is-visible');
        }, 1500);
      }
      
      this.bindEvents();
    },
    
    bindEvents() {
      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-cookie-accept-all]')) {
          this.acceptAll();
        }
        if (e.target.matches('[data-cookie-accept-necessary]')) {
          this.acceptNecessary();
        }
      });
    },
    
    acceptAll() {
      const consent = {
        necessary: true,
        analytics: true,
        marketing: true,
        preferences: true,
        timestamp: new Date().toISOString()
      };
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(consent));
      this.hideBanner();
    },
    
    acceptNecessary() {
      const consent = {
        necessary: true,
        analytics: false,
        marketing: false,
        preferences: false,
        timestamp: new Date().toISOString()
      };
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(consent));
      this.hideBanner();
    },
    
    hideBanner() {
      const banner = document.querySelector('.cookie-consent');
      if (banner) {
        banner.classList.remove('is-visible');
      }
    }
  };

  // ============================================
  // Mobile Menu
  // ============================================
  const MobileMenu = {
    init() {
      this.menu = document.querySelector('.mobile-menu');
      this.overlay = document.querySelector('.mobile-menu__overlay');
      this.bindEvents();
    },
    
    bindEvents() {
      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-mobile-menu-open]')) {
          this.open();
        }
        if (e.target.matches('[data-mobile-menu-close]') || e.target.matches('.mobile-menu__overlay')) {
          this.close();
        }
      });
    },
    
    open() {
      if (this.menu) this.menu.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    
    close() {
      if (this.menu) this.menu.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  // ============================================
  // Cart Drawer
  // ============================================
  const CartDrawer = {
    init() {
      this.drawer = document.querySelector('.cart-drawer');
      this.overlay = document.querySelector('.cart-drawer__overlay');
      this.bindEvents();
    },
    
    bindEvents() {
      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-cart-open]')) {
          e.preventDefault();
          this.open();
        }
        if (e.target.matches('[data-cart-close]') || e.target.matches('.cart-drawer__overlay')) {
          this.close();
        }
      });
    },
    
    open() {
      if (this.drawer) this.drawer.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    
    close() {
      if (this.drawer) this.drawer.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    
    async updateCart(updates) {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        });
        
        const cart = await response.json();
        this.refreshCartContents();
        this.updateCartCount(cart.item_count);
        
        return cart;
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    },
    
    async addToCart(id, quantity = 1) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: id,
            quantity: quantity
          })
        });
        
        const item = await response.json();
        this.refreshCartContents();
        this.open();
        
        return item;
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    },
    
    async refreshCartContents() {
      try {
        const response = await fetch('/?sections=cart-drawer-contents');
        const data = await response.json();
        
        const container = document.querySelector('[data-cart-contents]');
        if (container && data['cart-drawer-contents']) {
          container.innerHTML = data['cart-drawer-contents'];
        }
      } catch (error) {
        console.error('Error refreshing cart:', error);
      }
    },
    
    updateCartCount(count) {
      const countElements = document.querySelectorAll('[data-cart-count]');
      countElements.forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    }
  };

  // ============================================
  // Product Form
  // ============================================
  const ProductForm = {
    init() {
      this.bindEvents();
    },
    
    bindEvents() {
      document.addEventListener('submit', async (e) => {
        if (e.target.matches('[data-product-form]')) {
          e.preventDefault();
          
          const form = e.target;
          const submitBtn = form.querySelector('[type="submit"]');
          const originalText = submitBtn.textContent;
          
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding...';
          
          const formData = new FormData(form);
          const id = formData.get('id');
          const quantity = parseInt(formData.get('quantity')) || 1;
          
          await CartDrawer.addToCart(id, quantity);
          
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
    }
  };

  // ============================================
  // Quantity Selector
  // ============================================
  const QuantitySelector = {
    init() {
      this.bindEvents();
    },
    
    bindEvents() {
      document.addEventListener('click', (e) => {
        const decreaseBtn = e.target.closest('[data-quantity-decrease]');
        const increaseBtn = e.target.closest('[data-quantity-increase]');
        
        if (decreaseBtn) {
          this.decrease(decreaseBtn);
        }
        
        if (increaseBtn) {
          this.increase(increaseBtn);
        }
      });
    },
    
    decrease(btn) {
      const input = btn.closest('.quantity-selector').querySelector('input');
      const min = parseInt(input.min) || 1;
      const current = parseInt(input.value) || 1;
      
      if (current > min) {
        input.value = current - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },
    
    increase(btn) {
      const input = btn.closest('.quantity-selector').querySelector('input');
      const max = parseInt(input.max) || 999;
      const current = parseInt(input.value) || 1;
      
      if (current < max) {
        input.value = current + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  };

  // ============================================
  // Initialize
  // ============================================
  document.addEventListener('DOMContentLoaded', () => {
    CookieConsent.init();
    MobileMenu.init();
    CartDrawer.init();
    ProductForm.init();
    QuantitySelector.init();
  });

  // Expose to global scope
  window.VoltNova = {
    CartDrawer,
    CookieConsent
  };

})();
